import { useEffect, useState } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../config/api';

export function useCatalogue<T>(endpoint: string) {
  const [items, setItems] = useState<T[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [searchTerm, setSearchTerm] = useState('');
  const [query, setQuery] = useState({ search: '', page: 1 });
  const [totalPages, setTotalPages] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [revision, setRevision] = useState(0);
  useEffect(() => {
    const timer = window.setTimeout(() => setQuery(previous => previous.search === searchTerm.trim() ? previous : { search: searchTerm.trim(), page: 1 }), 300);
    return () => window.clearTimeout(timer);
  }, [searchTerm]);
  useEffect(() => {
    const controller = new AbortController();
    let active = true;
    setLoading(true);
    setError('');
    axios.get(API_BASE_URL + '/' + endpoint + '/', { params: { page: query.page, search: query.search }, signal: controller.signal })
      .then(response => { if (active) { setItems(response.data.results); setTotalPages(Math.max(1, response.data.total_pages || 1)); setTotalCount(response.data.count ?? response.data.results.length); } })
      .catch(() => { if (active) setError('Could not load results. Try again.'); })
      .finally(() => { if (active) setLoading(false); });
    return () => { active = false; controller.abort(); };
  }, [endpoint, query, revision]);
  const search = () => setQuery(previous => previous.search === searchTerm.trim() ? previous : { search: searchTerm.trim(), page: 1 });
  const changePage = (page: number) => setQuery(previous => ({ ...previous, page }));
  return { items, loading, error, searchTerm, setSearchTerm, currentPage: query.page, totalPages, totalCount, search, changePage, retry: () => setRevision(value => value + 1) };
}
